/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

export default {
      Nationalities: '$MHF_ModelNameVal_$MHF|Nationalities',

};
